import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Api } from 'src/smoothr-web-app-core/api/api';
import { RepositoryService } from 'src/smoothr-web-app-core/services/repository/repository.service';

@Component({
	selector: 'welcome-login-sso-modal',
	templateUrl: './welcome-login-sso-modal.component.html',
	styleUrls: ['./welcome-login-sso-modal.component.scss'],
})
export class WelcomeLoginSsoModalComponent implements OnInit {
	id: string = '';
	auth: string = '';
	name: string = '';

	constructor(
		private modalCtrl: ModalController,
		private router: Router,
		protected repository: RepositoryService
	) {}
	static async show(modalCtrl: ModalController, id, auth, name?) {
		const modal = await modalCtrl.create({
			cssClass: 'welcome',
			component: WelcomeLoginSsoModalComponent,
			componentProps: { id, auth, name },
			showBackdrop: true,
			backdropDismiss: true,
		});
		await modal.present();
		// const result = (await modal.onDidDismiss()).data;
		// return result;
	}
	ngOnInit() {
		this.loginWithSSO();
	}
	loginWithSSO() {
		// TODO: Rewrite to async/await
		try {
			Api.oneTimeLogin(this.id, this.auth)
				.then(res => {
					this.repository.customerAuth.emit(res.data);
				})
				.then(() => {
					setTimeout(async () => {
						this.name ? window.open('/order?name=' + this.name, '_self') : window.open('/order', '_self');
					}, 3000);
				});
		} catch (error) {
			console.log(error);
		}
	}
}
